export enum EACTIVE_TAB {
    "NON_PATIENT" = 0,
    "PATIENT" = 1
}
